export const formatNumber = (num) => {
    const numero = parseFloat(num);
    return numero.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };